// Character limits for free-text fields in the scan template editor.
// MAX_TASK_NAME_LENGTH lives in kai-presenters so taskNamePresenter truncates legacy names to the same limit.
export { MAX_TASK_NAME_LENGTH } from '@kaiizen/kai-presenters';

export const MAX_PART_DESCRIPTION_LENGTH = 1000;
export const MAX_VALUE_NAME_LENGTH = 32;
export const MAX_VALUE_EQUATION_LENGTH = 250;
export const MAX_NUMBER_INPUT_LENGTH = 20;
